
import Vue from 'vue';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import { CourseModel } from '@descomplica/dex-models';

export default Vue.extend({
  props: {
    isExpired: {
      required: true,
      type: Boolean,
    },
    errorWhileCreatingStudyPlanning: {
      required: true,
      type: Boolean,
    },
    openStudyPlanningModal: {
      required: true,
      type: Function,
    },
    course: {
      required: true,
      type: Object as Vue.PropType<CourseModel>,
    },
  },
  computed: {
    titleAndImageForError(): { title: string; imgUrl: string } {
      return {
        title: this.errorWhileCreatingStudyPlanning
          ? this.$tc('postgradStudyPlanning.invalidStudyPlanningError.creatingError')
          : this.$tc('postgradStudyPlanning.invalidStudyPlanningError.expiredError'),
        imgUrl: this.errorWhileCreatingStudyPlanning
          ? 'https://classrooms-assets.s3.sa-east-1.amazonaws.com/post-grad/curso-expirado-modal.svg'
          : 'https://classrooms-assets.s3.sa-east-1.amazonaws.com/post-grad/ilustra-fim-planej.svg',
      };
    },
  },
  created() {
    if (this.isExpired) {
      const { getCurrentChimeraCourse, getTrialStatusByDescomplicaCourseId } = this.$store.getters;

      Analytics.trackEvent(EVENT_LABELS.expiredPostgradStudyPlanningCardViewed, {
        course: this.course.name,
        category: 'pos',
        ...getTrialStatusByDescomplicaCourseId(getCurrentChimeraCourse?._id),
      });
    }
  },
  methods: {
    openModal(): void {
      this.openStudyPlanningModal();
    },
    retryCreateDefaultStudyPlanning(): void {
      this.$emit('retryCreatingDefaultStudyPlanning');
    },
  },
});
